import * as tslib_1 from "tslib";
import { ConsentString } from 'consent-string';
import { getUserConfiguration } from 'owa-session-store';
import { trace } from 'owa-trace';
import fetchVendorList from '../services/fetchVendorList';
export default function generateConsentString(allowAccess, allowPersonalization, allowAdSelection, allowContentSelection, allowMeasurement) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var vendorList, consentData, purposeFlags, allowedPurposes, vendorIds, culture, consentLanguage;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchVendorList()];
                case 1:
                    vendorList = _a.sent();
                    if (!vendorList) {
                        trace.error('Fetching vendor list failed.');
                        return [2 /*return*/, null];
                    }
                    consentData = new ConsentString();
                    consentData.setGlobalVendorList(vendorList);
                    purposeFlags = [
                        allowAccess,
                        allowPersonalization,
                        allowAdSelection,
                        allowContentSelection,
                        allowMeasurement,
                    ];
                    allowedPurposes = [];
                    purposeFlags.forEach(function (allowed, index) {
                        if (allowed) {
                            allowedPurposes.push(index + 1);
                        }
                    });
                    vendorIds = allowedPurposes.length > 0 ? vendorList.vendors.map(function (vendor) { return vendor.id; }) : [];
                    culture = getUserConfiguration().SessionSettings.UserCulture;
                    consentLanguage = culture ? culture.split('-')[0] : 'en';
                    // Set the consent data
                    // TODO: CMP ID, Version, Screen to be set when we receive that from AppNexus
                    consentData.setCmpId(1);
                    consentData.setCmpVersion(1);
                    consentData.setConsentScreen(1);
                    consentData.setConsentLanguage(consentLanguage);
                    consentData.setPurposesAllowed(allowedPurposes);
                    consentData.setVendorsAllowed(vendorIds);
                    // Encode the data into a web-safe base64 string
                    return [2 /*return*/, consentData.getConsentString()];
            }
        });
    });
}
//# sourceMappingURL=generateConsentString.js.map